<template>
  <div class="luggage-item">
    <div class="item-header">Genstand {{ itemIndex + 1 }}</div>
    
    <PhotoUploadSlot
      :person-index="personIndex"
      :luggage-type="luggageType"
      :item-index="itemIndex"
      :type="'luggage'"
      :photos="photos"
      :order-token="orderToken"
      @photoUploaded="photoUploaded"
      @photoDeleted="photoDeleted"
      @show-message="showMessage"
      @view-photo="viewPhoto"
    />
    
    <PhotoUploadSlot
      :person-index="personIndex"
      :luggage-type="luggageType"
      :item-index="itemIndex"
      :type="'barcode'"
      :photos="photos"
      :order-token="orderToken"
      @photoUploaded="photoUploaded"
      @photoDeleted="photoDeleted"
      @show-message="showMessage"
      @view-photo="viewPhoto"
    />
  </div>
</template>

<script>
import PhotoUploadSlot from './PhotoUploadSlot.vue'

export default {
  name: 'LuggageItem',
  components: {
    PhotoUploadSlot
  },
  props: {
    personIndex: {
      type: Number,
      required: true
    },
    luggageType: {
      type: String,
      required: true
    },
    itemIndex: {
      type: Number,
      required: true
    },
    photos: {
      type: Object,
      required: true
    },
    orderToken: {
      type: String,
      required: true
    }
  },
  methods: {
    photoUploaded(payload) {
      this.$emit('photoUploaded', payload)
      this.$emit('photo-uploaded', payload)
      
      // Fallback: direct parent call
      if (this.$parent && this.$parent.photoUploaded) {
        this.$parent.photoUploaded(payload)
      }
    },

    photoDeleted(payload) {
      this.$emit('photoDeleted', payload)
      this.$emit('photo-deleted', payload)
      
      // Fallback: direct parent call
      if (this.$parent && this.$parent.photoDeleted) {
        this.$parent.photoDeleted(payload)
      }
    },

    showMessage(message) {
      this.$emit('show-message', message)
    },

    viewPhoto(photoData) {
      this.$emit('view-photo', photoData)
    }
  }
}
</script>

<style lang="scss" scoped>
.luggage-item {
  border: 1px solid #E2E2E2;
  border-radius: 6px;
  padding: 15px;
  background: #F9F9F9;
}

.item-header {
  text-align: center;
  font-weight: 600;
  margin-bottom: 15px;
  color: #666;
  font-size: 12px;
  text-transform: uppercase;
}
</style> 